import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router/index';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './assets/scss/index.scss';
import './assets/index.css';
import apiClient from './plugins/axios';

const myApp = createApp(App);
myApp.config.globalProperties.$http = apiClient;

myApp.use(vuetify);
myApp.use(router);

myApp.mount('#app');
